import { Disposable } from '@patsnap/tahiti-core/common/disposable';
import { tryOnScopeDispose } from '@vueuse/core';

export function useDisposes() {
    const disposes: Disposable[] = [];

    tryOnScopeDispose(() => {
        disposes.forEach(_ => _.dispose());
    });

    return {
        disposes,
    };
}
